// Platform status: while the API is in a security cool-down it answers every
// public request with 503, and this endpoint (always served) says so.

export type PlatformStatus =
  | { state: "normal" }
  | {
      state: "paused";
      message: string;
      /** ISO time the pause is expected to end, when known. */
      until: string | null;
    };

export async function fetchPlatformStatus(): Promise<PlatformStatus> {
  const apiOrigin = import.meta.env.VITE_API_ORIGIN ?? "";
  const response = await fetch(`${apiOrigin}/public/status`, {
    credentials: "omit",
    cache: "no-store",
  });
  if (!response.ok) throw new Error(`status unavailable: ${response.status}`);
  const body = (await response.json()) as {
    state?: string;
    message?: string;
    until?: string | null;
  };
  if (body.state === "paused") {
    return {
      state: "paused",
      message: body.message ?? "",
      until: body.until ?? null,
    };
  }
  return { state: "normal" };
}
